export const AUTHENTICATED_SIGNUP_PENDING_STORAGE_KEY =
  "ecologi.authenticatedSignupPending";

export function setAuthenticatedSignupPending() {
  window.sessionStorage.setItem(
    AUTHENTICATED_SIGNUP_PENDING_STORAGE_KEY,
    "true"
  );
}

export function clearAuthenticatedSignupPending() {
  window.sessionStorage.removeItem(AUTHENTICATED_SIGNUP_PENDING_STORAGE_KEY);
}

export function hasAuthenticatedSignupPending() {
  return (
    typeof window !== "undefined" &&
    window.sessionStorage.getItem(AUTHENTICATED_SIGNUP_PENDING_STORAGE_KEY) ===
      "true"
  );
}

export function getAuthenticatedSignupReturnTo(
  asPath: string,
  params: Record<string, string | number | undefined>
) {
  const [pathname, search = ""] = asPath.split("?");
  const searchParams = new URLSearchParams(search);

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined) {
      searchParams.delete(key);
      return;
    }

    searchParams.set(key, String(value));
  });

  const queryString = searchParams.toString();
  return queryString ? `${pathname}?${queryString}` : pathname;
}
